'use client';

import clsx from 'clsx';
import { ProtegeLoader } from '~/components/Loading/ProtegeLoader';

/**
 * Route/page transition loader — Protege logomark with a Hookshot-style
 * pulsing-dot mask, centered in the content pane.
 * Used by all `loading.tsx` files and the workspace-access gate. App boot uses
 * `AppBootLoader` (the "P" Lottie); inline data loading uses `AppSpinner`.
 * See portal/AGENTS.md for the loading-state rules.
 */
export default function ContentPaneLoader({
  className,
  compact = false,
}: {
  className?: string;
  compact?: boolean;
}) {
  return (
    <div
      className={clsx(
        'grid w-full place-items-center p-6',
        // Pane/viewport: pin to the nearest positioned ancestor (the content
        // pane is `relative`) so the mark stays visually centered even when
        // percentage height on an in-flow child would collapse or sit high.
        // Nested slot (drawer, column, in-page): fill the parent instead of
        // covering the whole pane.
        compact
          ? 'relative h-full min-h-64 flex-1'
          : 'absolute inset-0 min-h-0',
        className,
      )}
    >
      <ProtegeLoader size="lg" />
    </div>
  );
}
